import axios from '../../axios';

/**
 * 204 doner; cerez yenilenmis sirket baglamiyla uzerine yazilir. Yanittan
 * okunacak bir token yok.
 */
export default async function subCompanySelectRequest(
  businessPartnerId: string
): Promise<void> {
  await axios.get(
    `${process.env.REACT_APP_BASE_URL}/hedefnet/sub-company/select`,
    {
      params: {
        businessPartnerId,
      },
    }
  );
}
